import { FILTER_VALUES } from './appConstants';

/** Check the raw fetchTicketDropdowns payload, before Redux renames its fields. */
export const getUnavailableSavedFilterFields = (criteria, options, isScrumProject) => {
  const fields = {
    selectedPriority: options.priority,
    selectedStatus: options.status,
    selectedAssignee: options.assignees,
    selectedCreatedBy: options.assignees,
    selectedTaskType: options.type,
    selectedLabels: options.labels,
    selectedSprint: isScrumProject ? options.scrum_sprints : options.sprint
  };
  return Object.entries(fields).filter(([field, items]) => {
    const values = Array.isArray(criteria[field]) ? criteria[field] : [criteria[field]];
    return values.some(value => value && value !== FILTER_VALUES.ALL &&
      !(items || []).some(item => String(item.id) === String(value)));
  }).map(([field]) => field);
};
